import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Immunization } from "@customTypes/immunization";
import { Pagination } from "@customTypes/index";

import { immunizationQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Immunization[] = [];

    for (const i in res.data.data) {
      const {
        _id,
        reason,
        medication_name,
        doses,
        administered_by,
        aid,
        date,
        patient_id,
        consultation_id,
        consultation_info,
        fast_consultation,
        files,
        created_at,
        updated_at,
      } = res.data.data[i];

      if (fast_consultation && consultation_info) {
        newData.push({
          id: _id,
          medication: "N/A",
          consultationId: consultation_id,
          consultationInfo: {
            consultationType: consultation_info?.consultation_type,
            physician: {
              id: consultation_info?.physician?._id,
              fullName: consultation_info?.physician?.full_name,
            },
          },
          patientId: patient_id,
          immunizationDate: new Date(date),
          date: new Date(date),
          files,
          doses: "N/A",
          administeredBy: {
            id: administered_by?._id,
            fullName: administered_by?.full_name,
          },
          supportStaff: {
            id: aid?._id,
            fullName: aid?.full_name,
          },
          reason,
          createdAt: new Date(created_at),
          updatedAt: new Date(updated_at),
          isFastConsultation: fast_consultation,
        });
      } else {
        newData.push({
          id: _id,
          medication: medication_name,
          consultationId: consultation_id,
          patientId: patient_id,
          immunizationDate: new Date(date),
          date: new Date(date),
          files,
          doses,
          administeredBy: {
            id: administered_by?._id,
            fullName: administered_by?.full_name,
          },
          supportStaff: {
            id: aid?._id,
            fullName: aid?.full_name,
          },
          reason,
          createdAt: new Date(created_at),
          updatedAt: new Date(updated_at),
          isFastConsultation: fast_consultation,
        });
      }
    }

    // console.log(newData);
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  patientId: string;
  withFilesOnly?: boolean;
  fastConsultationOnly?: boolean;
  pagination?: Partial<Pagination>;
  search?: string;
  isEnabled?: boolean;
}

export const useGetImmunizationsForPatient = ({
  patientId,
  withFilesOnly = false,
  fastConsultationOnly,
  isEnabled = true,
  pagination,
  search = "",
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: immunizationQKeys.patientWithFilters(patientId, {
      withFilesOnly,
      fastConsultationOnly,
      pagination,
      ...(search && { search }),
    }),
    queryFn: () => {
      return api.get(`preventative/patient/${patientId}`, {
        params: {
          only_with_files: withFilesOnly,
          ...(fastConsultationOnly !== undefined && {
            fast_consultation: fastConsultationOnly,
          }),
          ...(search && { search }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
        },
      });
    },
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Immunizations for Patient]", res);
      handleErrors(res, "query");
    },
  });
};
